export function Currency(client) {
    return {
        get() {
            return client.get('/currencies');
        }
    };
}
